import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=e901693a&scoped=true&"
import script from "./effect.vue?vue&type=script&lang=js&"
export * from "./effect.vue?vue&type=script&lang=js&"
import style0 from "./effect.vue?vue&type=style&index=0&id=e901693a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e901693a",
  null
  
)

export default component.exports